module.exports = __webpack_public_path__ + "img/full6-min.98f6f29a.png";